import React from 'react';
import PropTypes from 'prop-types';
import connectedRouterHOC from '../../utils/connectedRouterHOC';
import ContentContainer from '../contentContainer';
import MessagePanel from '../messagePanel';
import PageLayout from '../pageLayout';
import { emptySaveResult } from '../../variables';
import { get, post } from '../../utils/ajax';
import { showSuccessNotification, showErrorNotification } from '../../reducers/notifications';
import { canEditAnyPeriod } from '../../selectors/canEdit';
import { withForm } from '../../utils/forms';
import {
	Grid,
	List,
	ListItem,
	ListItemText
} from '@material-ui/core';
import TextField from '../widgets/TextField';
import map from 'lodash/map';
import { commentTemplateReplaceFields } from '../../reducers/progressClaims';

const commentTemplateForm = {
	initValues: ({
	}) => {
		console.log('initValues');
		return { 
			name: '',
			comment: '',
			isActive: true,
		};
	},
	fields: [
		{
			name: "name",
			label: "Name",
			required: false
		},
		{
			name: "comment",
			label: "Comment",
			type: "custom",
			widget: props => {
				let myRef = React.createRef();

				return (
                    <div style={{ display: 'flex' }}>
						<TextField 
								fullWidth={true}
								required={true}
								value={props.value}
								label="Comment"
								onChange={e => props.onChange(e.target.value)}
								multiline={true}
								rows={12}
								inputRef={myRef}

						/>
						<div>
							<div>
								<div
								style={{
									textTransform: 'uppercase',
									fontWeight: 'bold',
									textAlign: 'center'
								}}
								>
									Insert
								</div>
								<List style={{ padding: 0, overflowY: 'auto', maxHeight: '250px' }}>
									{
										map(commentTemplateReplaceFields, (v, i) => {
											return (
												<ListItem
													button
													key={i}
													onClick={() => {
														props.onChange(props.value + `?${v.text}?`);
														myRef.current.focus();
													}}
													style={{ 
														whiteSpace: 'nowrap',
														padding: '0px 5px 0px 5px',
													}}
												>
													<ListItemText 
														primary={v.name}
													/>
												</ListItem>
											);
										})
									}
								</List>
							</div>
						</div>
					</div>
                );
			}
		},
		{
			name: "isActive",
			label: "Is Active",
			type: 'checkbox'
		}
	]
};

const ProgressClaimCommentTemplateMaintenance = ({ 
	match,
	showSuccessNotification,
	showErrorNotification,
	history,
	canEdit,
	fields,
	values,
	updateValues,
	dirty,
	validateFields
}) => {
	const [state, setState] = React.useState({
		isLoading: false,
		saveResult: emptySaveResult,
	});

	React.useEffect(() => {
		if (match.params.commentTemplateId) {
			setState(prevState => ({ ...prevState, isLoading: true }));
			get({
				url: `/api/progress-claim/comment-templates/${match.params.commentTemplateId}`,
				onSuccess: data => {
					updateValues(data);
					setState(prevState => ({ ...prevState, isLoading: false }))
				},
				onError: (error) => {
					setState(prevState => ({ ...prevState, isLoading: false }));
					showErrorNotification(error.message);
				}
			});
		}
	}, [match.params.commentTemplateId]);

	const save = (onSuccess) => {
		if (!validateFields()) return;

		setState(prevState => ({ ...prevState, isLoading: true, saveResult: emptySaveResult }));
			
		post({
			url: `/api/progress-claim/comment-templates`,
			data: values,
			onSuccess: data => {
				setState({ 
					isLoading: false, 
					commentTemplate: data.success ? data.object : values,
					saveResult: {
						success: data.success,
						message: data.message,
						fields: data.fields
					} 
				});

				if (data.success) {
					showSuccessNotification(data.message);
					if (onSuccess) onSuccess();
				} else {
					showErrorNotification(data.message);
				}
			},
			onError: error => {
				setState(prevState => ({ ...prevState, isLoading: false }));
				showErrorNotification(error.message);
			}
		});
	};
	const saveChanges = () => save(() => { history.goBack(); });
	const saveChangesAndContinue = () => save();

	return (
		<PageLayout
			title={values ? values.name : ''}
			isLoading={state.isLoading}
			formActions={{
				isLoading: state.isLoading,
				canEdit: canEdit,
				hasUnsavedChanges: dirty,
				onSave: () => saveChanges(values),
				onSaveAndContinue: () => saveChangesAndContinue(values),
				onCancel: () => history.goBack()
			}}
			content={
				<div>
					<ContentContainer>
						<Grid container spacing={1}>
							<Grid item xs={12}>{fields.name()}</Grid>
							<Grid item xs={12}>{fields.comment()}</Grid>
							<Grid item xs={12}>{fields.isActive()}</Grid>
						</Grid>
					</ContentContainer>

					<MessagePanel 
						isSuccess={state.saveResult.success} 
						message={state.saveResult.message} 
					/>
				</div>
			}
		/>
	);
};

ProgressClaimCommentTemplateMaintenance.propTypes = {
	canEdit: PropTypes.bool.isRequired,
	showSuccessNotification: PropTypes.func.isRequired,
	showErrorNotification: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
	canEdit: canEditAnyPeriod(state, 'EditProgressClaims')
});

const mapDispatchToProps = (dispatch) => ({
	showSuccessNotification: message => dispatch(showSuccessNotification(message)),
	showErrorNotification: message => dispatch(showErrorNotification(message)),
});

export default connectedRouterHOC(
	mapStateToProps,
	mapDispatchToProps
)(withForm(commentTemplateForm)(ProgressClaimCommentTemplateMaintenance));
